import styled, { css, keyframes } from 'styled-components';

import { device } from '@/styles/helpers';

const scale = keyframes`
    0%   { transform: scale(1,1) translateY(0); }
    10%  { transform: scale(1.1,.9) translateY(0); }
    30%  { transform: scale(.9,1.1) translateY(-3px); }
    32%  { transform: scale(1.09) translateY(-3px); }
    35%, 40% { transform: scale(1.09) translateY(-3px) rotate(-20deg)}
    45%, 50% { transform: scale(1.09) translateY(-3px) rotate(20deg)}
    60%  { transform: scale(1.05,.95) translateY(0); }
    70%  { transform: scale(1.05,.95) translateY(0); }
    80%  { transform: scale(1,1) translateY(-1px); }
    95%  { transform: scale(1,1) translateY(0); }
    100% { transform: scale(1,1) translateY(0); }
`;

export const ScLabelsSection = styled.div`
  display: flex;
  column-gap: 8px;
`;

export const ScPromoLabel = styled.div<{ disableAnimation?: boolean }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.grayLightColor};
  overflow: hidden;
  cursor: pointer;

  @media (${device.mobile}) {
    width: 40px;
    height: 40px;
  }

  & > .label {
    position: relative;
    display: grid;
    place-items: center;
    width: 40px;
    height: 40px;
    ${({ disableAnimation }) =>
      !disableAnimation &&
      css`
        animation: ${scale} 2s ease infinite;
      `}

    transition: scale 0.2s ease-in-out;
    z-index: 1;

    & > span {
      position: relative;
      font-size: 16px;
      font-weight: 700;
      line-height: 20px;
      z-index: 2;
    }
  }

  & > img {
    position: absolute;
    left: 4px;
    top: 4px;
    @media (${device.mobile}) {
      left: 0;
      top: 0;
    }
  }

  @media (hover: hover) {
    &:hover {
      & > img {
        &:first-child {
          animation: none;
          scale: 1.2;
        }
      }
    }
  }
`;
